module.exports = __webpack_public_path__ + "static/media/122-umbrella.086ee750.svg";